<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        class="text-center"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import paths from '../router/paths.js'
  export default {
    computed: {
      user: function () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.$router.push(this.getRedirect(this.user))
    },
    methods: {
      getRedirect (user) {
        if (!user) {
          return '/login'
        }
        var role = user.role.toLowerCase()
        if (!role) {
          role = 'default'
        }
        return paths.find(path => path.roles && path.roles.indexOf(role.toLowerCase()) > -1).path
      }
    }
  }
</script>
